export default () => ({
  input: undefined,
  list: undefined,
  liSelected: undefined,
  init() {
    mrp.log(`RxPickerControl init`);
    // the ref to the input element
    this.input = this.$refs.input;
    // the ref to the list container div
    this.list = this.$refs.list;
  },
  // this function is a trigger bound to the ul list
  listDisplayed() {
    mrp.log(`listDisplayed fired`);
    // set the input's aria-expanded to true
    this.input?.setAttribute("aria-expanded", "true");
    return true;
  },
  escape() {
    mrp.log(`escape key pressed`);
    // focus the input
    this.input.focus();
    // set the input's aria-expanded to false
    this.input.setAttribute("aria-expanded", "false");
    // remove all elements (the ul)
    while (this.list.firstChild) {
      this.list.removeChild(this.list.firstChild);
    }
  },
  inputKeyup(evt) {
    mrp.log(`input keyup pressed`);
    this.cancelEvent(evt);
    if (!this.list.firstChild) {
      // no ul so bail out
      return;
    }
    // select the ul's last li
    this.setListItem(this.list.firstChild.lastChild);
  },
  inputKeydown(evt) {
    mrp.log(`input keydown pressed`);
    this.cancelEvent(evt);
    if (!this.list.firstChild) {
      // no ul so bail out
      return;
    }
    // select the ul's first li
    this.setListItem(this.list.firstChild.firstChild);
  },
  listKeyup(evt) {
    mrp.log(`list keyup pressed`);
    this.cancelEvent(evt);
    if (!this.liSelected) {
      // no selected li so bail out
      return;
    }
    // select the previous li
    this.setListItem(this.liSelected.previousSibling);
  },
  listKeydown(evt) {
    mrp.log(`list keydown pressed`);
    this.cancelEvent(evt);
    if (!this.liSelected) {
      // no selected li so bail out
      return;
    }
    // select the next li
    this.setListItem(this.liSelected.nextSibling);
  },
  cancelEvent(evt) {
    evt.preventDefault();
    evt.stopPropagation();
  },
  setListItem(ele) {
    mrp.log(`set selected li element`);
    if (!ele) {
      // no previous/next li so bail out - maybe allow rollover to the bottom?
      return;
    }
    // aria deselect the current selected li
    if (this.liSelected) {
      this.liSelected.setAttribute("aria-selected", "false");
    }
    // keep the new selected li ref
    this.liSelected = ele;
    // set the aria selected attr
    this.liSelected.setAttribute("aria-selected", "true");
    // focus the button
    this.liSelected.firstChild.focus();
  },
});
